
export default {

  SET_RELATIONSHIP_RULE_CATEGORY_PAGINATED(state, relationshipRuleCategory) {
    state.relationshipRuleCategory = relationshipRuleCategory;
  },
  ADD_CATEGORY(state, relationshipRuleCategory) {
    state.relationshipRuleCategory = relationshipRuleCategory
  },
  DELETE_CATEGORY(state, id) {
    const itemIndex = state.relationshipRuleCategory.items.findIndex(value => value.id === id);
    if (itemIndex !== -1) {
      state.relationshipRuleCategory.items.splice(itemIndex, 1);
    }
  }
}
